import {AbstractControl, ValidationErrors} from "@angular/forms";

export function containsNumberValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value || /\d/.test(control.value)) {
    return null;
  }

  control.setErrors({containsNumber: true});
  return {containsNumber: true};
}
